// Système de filtres AJAX personnalisé - Remplace le système Dawn

// Détecter si on est dans l'interface d'administration Shopify
function isShopifyAdmin() {
  return window.location.hostname.includes('myshopify.com') && 
         (window.location.pathname.includes('/admin') || 
          window.location.pathname.includes('/themes') ||
          window.location.pathname.includes('/customize'));
}

// EMPÊCHER COMPLÈTEMENT le système Dawn original
document.addEventListener('DOMContentLoaded', function() {
  // Ne pas exécuter dans l'interface d'administration Shopify
  if (isShopifyAdmin()) {
    return;
  }
  // Intercepter TOUS les événements de soumission de formulaires
  document.addEventListener('submit', function(event) {
    const form = event.target;
    if (form.closest('facet-filters-form') || form.id === 'FacetFiltersForm' || form.id === 'FacetFiltersFormMobile') {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return false;
    }
  }, true);
  
  // Intercepter TOUS les changements d'inputs dans les formulaires de filtres
  document.addEventListener('input', function(event) {
    const target = event.target;
    if (target.closest('facet-filters-form') || target.closest('#FacetFiltersForm') || target.closest('#FacetFiltersFormMobile')) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      
      // Déclencher notre système AJAX
      const form = target.closest('form');
      if (form) {
        const formData = new FormData(form);
        const searchParams = new URLSearchParams(formData).toString();
        FacetFiltersForm.renderPageAjax(searchParams, event);
      }
      
      return false;
    }
  }, true);
  
  // Intercepter SPÉCIALEMENT les inputs de prix
  document.addEventListener('change', function(event) {
    // Ne pas exécuter dans l'interface d'administration Shopify
    if (isShopifyAdmin()) {
      return;
    }
    
    const target = event.target;
    if (target.name && target.name.includes('price') && 
        (target.closest('facet-filters-form') || target.closest('#FacetFiltersForm') || target.closest('#FacetFiltersFormMobile'))) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      
      // Déclencher notre système AJAX
      const form = target.closest('form');
      if (form) {
        const formData = new FormData(form);
        const searchParams = new URLSearchParams(formData).toString();
        FacetFiltersForm.renderPageAjax(searchParams, event);
      }
      
      return false;
    }
  }, true);
  
  // Intercepter aussi les événements 'input' sur les champs de prix
  document.addEventListener('input', function(event) {
    // Ne pas exécuter dans l'interface d'administration Shopify
    if (isShopifyAdmin()) {
      return;
    }
    
    const target = event.target;
    if (target.name && target.name.includes('price') && 
        (target.closest('facet-filters-form') || target.closest('#FacetFiltersForm') || target.closest('#FacetFiltersFormMobile'))) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      
      // Déclencher notre système AJAX
      const form = target.closest('form');
      if (form) {
        const formData = new FormData(form);
        const searchParams = new URLSearchParams(formData).toString();
        FacetFiltersForm.renderPageAjax(searchParams, event);
      }
      
      return false;
    }
  }, true);
  
  // Intercepter aussi les événements 'blur' sur les champs de prix
  document.addEventListener('blur', function(event) {
    // Ne pas exécuter dans l'interface d'administration Shopify
    if (isShopifyAdmin()) {
      return;
    }
    
    const target = event.target;
    if (target.name && target.name.includes('price') && 
        (target.closest('facet-filters-form') || target.closest('#FacetFiltersForm') || target.closest('#FacetFiltersFormMobile'))) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      
      // Déclencher notre système AJAX
      const form = target.closest('form');
      if (form) {
        const formData = new FormData(form);
        const searchParams = new URLSearchParams(formData).toString();
        FacetFiltersForm.renderPageAjax(searchParams, event);
      }
      
      return false;
    }
  }, true);
  
  // Intercepter TOUS les changements de checkboxes et radios
  document.addEventListener('change', function(event) {
    const target = event.target;
    if ((target.type === 'checkbox' || target.type === 'radio') && 
        (target.closest('facet-filters-form') || target.closest('#FacetFiltersForm') || target.closest('#FacetFiltersFormMobile'))) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      
      // Déclencher notre système AJAX
      const form = target.closest('form');
      if (form) {
        const formData = new FormData(form);
        const searchParams = new URLSearchParams(formData).toString();
        FacetFiltersForm.renderPageAjax(searchParams, event);
      }
      
      return false;
    }
  }, true);
});

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    
    // Initialiser les event listeners pour AJAX
    this.initializeAjaxListeners();
  }

  static setListeners() {
    // Gestion de l'historique du navigateur
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPageAjax(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  // NOUVELLE MÉTHODE : Rendu AJAX au lieu de rechargement
  static renderPageAjax(searchParams, event, updateURLHash = true) {
    
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    
    // Afficher les indicateurs de chargement
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    const productGrid = document.getElementById('ProductGridContainer');
    if (productGrid) {
      productGrid.querySelector('.collection').classList.add('loading');
    }
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    // Faire les requêtes AJAX
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      FacetFiltersForm.fetchSectionAjax(url, event);
    });

    // Mettre à jour l'URL sans rechargement
    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(searchParams);
    }
  }

  // NOUVELLE MÉTHODE : Fetch AJAX pour une section
  static fetchSectionAjax(url, event) {
    
    fetch(url, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'text/html'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.text();
    })
    .then(html => {
      
      // Parser le HTML de réponse
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Mettre à jour la grille de produits
      FacetFiltersForm.updateProductGrid(doc);
      
      // Mettre à jour les filtres
      FacetFiltersForm.updateFilters(doc, event);
      
      // Mettre à jour le compteur de produits
      FacetFiltersForm.updateProductCount(doc);
      
      // Cacher les indicateurs de chargement
      FacetFiltersForm.hideLoadingSpinners();
    })
    .catch(error => {
      FacetFiltersForm.hideLoadingSpinners();
    });
  }

  // NOUVELLE MÉTHODE : Mettre à jour la grille de produits
  static updateProductGrid(doc) {
    
    const newProductGrid = doc.getElementById('ProductGridContainer');
    const currentProductGrid = document.getElementById('ProductGridContainer');
    
    
    if (newProductGrid && currentProductGrid) {
      
      // Sauvegarder le bouton "Voir plus" actuel avant la mise à jour
      const currentLoadMoreBtn = document.getElementById('load-more-btn');
      
      currentProductGrid.innerHTML = newProductGrid.innerHTML;
      
      // Réinitialiser les animations
      currentProductGrid.querySelectorAll('.scroll-trigger').forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
      
      // Mettre à jour le bouton "Voir plus" avec les paramètres actuels
      const newLoadMoreBtn = document.getElementById('load-more-btn');
      if (newLoadMoreBtn) {
        const newNextUrl = newLoadMoreBtn.getAttribute('data-next-url');
        if (newNextUrl) {
          try {
            // Récupérer tous les paramètres de l'URL actuelle (filtres + tri)
            const currentUrl = new URL(window.location.href);
            const currentParams = new URLSearchParams(currentUrl.search);
            
            // Extraire le numéro de page de la nouvelle URL
            const newUrlObj = new URL(newNextUrl, window.location.origin);
            const newParams = new URLSearchParams(newUrlObj.search);
            const pageParam = newParams.get('page');
            
            // Construire la nouvelle URL avec tous les paramètres actuels + la page suivante
            const finalUrlObj = new URL(window.location.pathname, window.location.origin);
            const finalParams = new URLSearchParams(currentParams);
            
            // Ajouter/mettre à jour le paramètre de page
            if (pageParam) {
              finalParams.set('page', pageParam);
            }
            
            // Construire l'URL finale
            finalUrlObj.search = finalParams.toString();
            const finalUrl = finalUrlObj.toString();
            
            // Mettre à jour l'attribut data-next-url
            newLoadMoreBtn.setAttribute('data-next-url', finalUrl);
          } catch (error) {
            // Erreur silencieuse lors de la mise à jour du bouton
          }
        }
      }
      
      // Déclencher un événement pour mettre à jour le bouton "Voir plus"
      document.dispatchEvent(new CustomEvent('facetFiltersUpdated'));
    } else {
    }
  }

  // NOUVELLE MÉTHODE : Mettre à jour les filtres
  static updateFilters(doc, event) {
    const newFilters = doc.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const currentFilters = document.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    
    // Supprimer les filtres qui n'existent plus
    Array.from(currentFilters).forEach((currentElement) => {
      if (!Array.from(newFilters).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });
    
    // Ajouter ou mettre à jour les filtres
    newFilters.forEach((newElement) => {
      const currentElement = document.getElementById(newElement.id);
      if (currentElement) {
        currentElement.innerHTML = newElement.innerHTML;
      } else {
        // Ajouter le nouveau filtre
        const parentElement = document.querySelector(`#${newElement.parentElement.id}`);
        if (parentElement) {
          parentElement.appendChild(newElement);
        }
      }
    });
    
    // Mettre à jour les filtres actifs
    FacetFiltersForm.updateActiveFacets(doc);
  }

  // NOUVELLE MÉTHODE : Mettre à jour les filtres actifs
  static updateActiveFacets(doc) {
    const activeFacetSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
    
    activeFacetSelectors.forEach((selector) => {
      const newActiveFacets = doc.querySelector(selector);
      const currentActiveFacets = document.querySelector(selector);
      
      if (newActiveFacets && currentActiveFacets) {
        currentActiveFacets.innerHTML = newActiveFacets.innerHTML;
      }
    });
    
    FacetFiltersForm.toggleActiveFacets(false);
  }

  // NOUVELLE MÉTHODE : Mettre à jour le compteur de produits
  static updateProductCount(doc) {
    const newCount = doc.getElementById('ProductCount');
    const currentCount = document.getElementById('ProductCount');
    const currentCountDesktop = document.getElementById('ProductCountDesktop');
    
    if (newCount && currentCount) {
      currentCount.innerHTML = newCount.innerHTML;
      currentCount.classList.remove('loading');
      
      if (currentCountDesktop) {
        currentCountDesktop.innerHTML = newCount.innerHTML;
        currentCountDesktop.classList.remove('loading');
      }
    }
  }

  // NOUVELLE MÉTHODE : Cacher les indicateurs de chargement
  static hideLoadingSpinners() {
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
    
    const productGrid = document.getElementById('ProductGridContainer');
    if (productGrid) {
      productGrid.querySelector('.collection').classList.remove('loading');
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  // NOUVELLE MÉTHODE : Initialiser les listeners AJAX
  initializeAjaxListeners() {
    const facetForm = this.querySelector('form');
    if (!facetForm) return;
    
    // EMPÊCHER COMPLÈTEMENT le système Dawn
    facetForm.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return false;
    });
    
    // Intercepter TOUS les changements d'inputs
    facetForm.addEventListener('input', (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.handleInputChange(event);
    });
    
    // Intercepter TOUS les changements de checkboxes
    const checkboxes = this.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        this.handleCheckboxChange(event);
      });
    });
    
    // Intercepter TOUS les changements de radios
    const radios = this.querySelectorAll('input[type="radio"]');
    radios.forEach(radio => {
      radio.addEventListener('change', (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        this.handleRadioChange(event);
      });
    });
  }

  // NOUVELLE MÉTHODE : Gérer les changements d'input
  handleInputChange(event) {
    
    // Créer les paramètres de recherche
    const searchParams = this.createSearchParams(event.target.closest('form'));
    
    // Déclencher SEULEMENT le rendu AJAX
    FacetFiltersForm.renderPageAjax(searchParams, event);
  }

  // NOUVELLE MÉTHODE : Gérer les changements de checkbox
  handleCheckboxChange(event) {
    
    // Créer les paramètres de recherche
    const searchParams = this.createSearchParams(event.target.closest('form'));
    
    // Déclencher SEULEMENT le rendu AJAX
    FacetFiltersForm.renderPageAjax(searchParams, event);
  }

  // NOUVELLE MÉTHODE : Gérer les changements de radio
  handleRadioChange(event) {
    
    // Créer les paramètres de recherche
    const searchParams = this.createSearchParams(event.target.closest('form'));
    
    // Déclencher SEULEMENT le rendu AJAX
    FacetFiltersForm.renderPageAjax(searchParams, event);
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPageAjax(url);
  }
}

// Initialisation
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// Classe pour les gammes de prix (modifiée pour AJAX)
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    
    // Empêcher le comportement par défaut
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    
    // Déclencher notre système AJAX
    const form = event.target.closest('form');
    if (form) {
      const formData = new FormData(form);
      const searchParams = new URLSearchParams(formData).toString();
      FacetFiltersForm.renderPageAjax(searchParams, event);
    }
    
    return false;
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') maxInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

// Classe pour supprimer les filtres (inchangée)
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);